export default {
    auth: {
      isLoading: false,
      error: false,
      user: {}
    }
  }